import { Col, Table } from "reactstrap";
import { H3, H6, Image, P } from "../../../../../../AbstractElements";
import { CurrentCartTitle } from "../../../../../../Constants/Constants";
import { CurrentCartTableBodyData, CurrentCartTableFooterData } from "../../../../../../Data/Forms&Table/Forms/FormLayout";
import { dynamicImage } from "../../../../../../Utils";

const CurrentCart = () => {
  return (
    <Col xl="4">
      <div className="shipping-info">
        <H3>{CurrentCartTitle}</H3>
        <div className="overflow-auto custom-scrollbar">
          <Table striped>
            <thead>
              <tr>
                <th scope="col">{"Product"}</th>
                <th scope="col">{"Product Detail"}</th>
                <th scope="col">{"Price"}</th>
              </tr>
            </thead>
            <tbody>
              {CurrentCartTableBodyData.map((data, index) => (
                <tr key={index}>
                  <td><Image src={dynamicImage(data.imagePath)} alt="t-shirt" /></td>
                  <td><div><H6>{data.productName}</H6><span>{data.productSum}</span></div></td>
                  <td><P>{data.price}</P></td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              {CurrentCartTableFooterData.map((data, index) => (
                <tr key={index}>
                  <td>{data.footerTittle}</td>
                  <td colSpan={2}>{"$"}{data.price}</td>
                </tr>
              ))}
            </tfoot>
          </Table>
        </div>
      </div>
    </Col>
  );
};

export default CurrentCart;
